import _get from 'lodash/get';
import isMiles from '../../utils/is-miles';

export function vehicleTitle(state) {
  return (
    isMiles(state.quote)
      ? [state.quote.variant.modelYear, state.quote.variant.name]
      : [
          state.quote.variant.modelYear,
          state.quote.make.description,
          state.quote.model.name,
          state.quote.variant.name
        ]
  )
    .filter(Boolean)
    .join(' ')
    .toLocaleLowerCase();
}

export function vehicleSubTitle(state) {
  const doors = state.quote.variant.doors
    ? `${state.quote.variant.doors} DR`
    : undefined;
  const speed = state.quote.variant.gears
    ? `${state.quote.variant.gears}sp`
    : undefined;
  const size = state.quote.variant.fuelTankCapacity
    ? `${state.quote.variant.fuelTankCapacity}L`
    : undefined;
  return [
    state.quote.exteriorColour.name,
    state.quote.bodyType,
    doors,
    state.quote.variant.transmission,
    speed,
    size
  ]
    .filter(Boolean)
    .join(' ')
    .toLocaleLowerCase();
}

export function vehicleImage(state) {
  return _get(state, 'quote.variant.photos[0].path');
}
